import type { StaticImageData } from 'next/image';
import ErrorLoadingPageSvg from 'public/img/illustrations/error-document.svg';
import ErrorCloneTransactionSvg from 'public/img/illustrations/error-two-documents.svg';
import { InteractionType } from '@/common/types/interaction';

export const PROPERTY_INFO_HEADER_TEXT = {
  [InteractionType.listing]: 'Tell us about the property being sold',
  [InteractionType.offer]: 'Tell us about the property being purchased',
  [InteractionType.lease]: 'Tell us about the property being leased',
  [InteractionType.clientGroup]: '',
  [InteractionType.referral]: '',
};

export const PROPERTY_INFO_AUTOFILL_WARNING =
  'If the address is autofilled from the MLS, please review the address to make sure it’s complete and correct.';

export const PROPERTY_INFO_SUBHEADER_TEXT = {
  [InteractionType.listing]: '',
  [InteractionType.offer]: PROPERTY_INFO_AUTOFILL_WARNING,
  [InteractionType.lease]: '',
  [InteractionType.clientGroup]: '',
  [InteractionType.referral]: '',
};

export const NEW_INTERACTION_ERRORS = {
  errorCloneTransaction: {
    svg: ErrorCloneTransactionSvg as StaticImageData,
    title: 'Error Cloning Transaction',
  },
  errorLoadingPage: {
    svg: ErrorLoadingPageSvg as StaticImageData,
    title: 'Error Loading Page',
  },
};

export const NEW_INTERACTION_SUBHEADER_TEXT: Partial<
  Record<InteractionType, string>
> = {
  [InteractionType.listing]:
    'Start a listing with just a few pieces of information',
  [InteractionType.offer]:
    'Pull information automatically about the property or fill in the details from scratch',
};
